import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../shared/services/school.service";
import { AutoPointInsertRequest } from "../shared/AutoPointInsertRequest";
import { AutoPointModifyRequest } from "../shared/AutoPointModifyRequest";
import { DataService_PBISAuto } from "../shared/data.service";

@Component({
	selector: "app-auto-point-modify",
	templateUrl: "./auto-point-modify.component.html",
	styleUrls: ["./auto-point-modify.component.css"],
})
export class AutoPointModifyComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private autoService: DataService_PBISAuto
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.MainTypeID = this.dialogConfig.data.PointsAutomatedItemTypeID;
			this.MainPointID = this.dialogConfig.data.PointsItemID;
		}

		this.loadSchools();
	}

	////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////

	EditMode: any = false;
	SelectedSchools: any = [];

	MainTypeID: any = -1;
	MainPointID: any = -1;

	TriggerLoading: any = true;
	lstTriggers: any = [];
	SelectedTrigger: any;

	PBISLoading: any = true;
	lstPBIS: any = [];
	SelectedPBIS: any;

	Processing: any = false;

	errorMessage: any = "";

	///////////////
	// Table
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////

	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////////

	loadSchools() {
		this.loading = true;

		var result = this.schoolService.loadSchoolList("40D815CE-35A8-4664-96E7-EDF2CD511C68");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.EditMode == true) {
					this.SelectedSchools = this.dialogConfig.data.lstSchools;
				}

				this.loadTriggerTypes();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadTriggerTypes() {
		this.TriggerLoading = true;

		var result = this.autoService.AutoPointTriggerSelectList();
		result.subscribe(
			(response) => {
				this.lstTriggers = response;

				this.SelectedTrigger = this.lstTriggers[0];

				if (this.EditMode == true) {
					for (var z = 0; z < this.lstTriggers.length; z++) {
						var next = this.lstTriggers[z];

						if (next.PointsAutomatedItemTypeID == this.MainTypeID) {
							this.SelectedTrigger = next;
						}
					}
				}

				this.loadPoints();

				this.TriggerLoading = false;
			},
			(error) => {
				this.TriggerLoading = false;
			}
		);
	}

	loadPoints() {
		this.PBISLoading = true;

		var result = this.autoService.AutoPointPBISSelectList();
		result.subscribe(
			(response) => {
				this.lstPBIS = response;

				this.SelectedPBIS = this.lstPBIS[0];

				if (this.EditMode == true) {
					for (var z = 0; z < this.lstPBIS.length; z++) {
						var next = this.lstPBIS[z];

						if (next.PointsItemID == this.MainPointID) {
							this.SelectedPBIS = next;
						}
					}
				}

				this.PBISLoading = false;
			},
			(error) => {
				this.PBISLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select at least 1 school to add the automatic points to";
			return;
		}

		this.Processing = true;

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			lstIDs = [...lstIDs, next.SchoolID];
		}

		var parms: AutoPointInsertRequest = {
			PointsAutomatedItemTypeID: this.SelectedTrigger.PointsAutomatedItemTypeID,
			PointsItemID: this.SelectedPBIS.PointsItemID,
			lstSchoolIDs: lstIDs,
		};

		var result = this.autoService.AutoPointInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Automatic PBIS points added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the automatic PBIS points: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		this.errorMessage = "";

		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select at least 1 school to add the automatic points to";
			return;
		}

		this.Processing = true;

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			lstIDs = [...lstIDs, next.SchoolID];
		}

		var parms: AutoPointModifyRequest = {
			OldPointsAutomatedItemTypeID: this.MainTypeID,
			OldPointsItemID: this.MainPointID,
			PointsAutomatedItemTypeID: this.SelectedTrigger.PointsAutomatedItemTypeID,
			PointsItemID: this.SelectedPBIS.PointsItemID,
			lstSchoolIDs: lstIDs,
		};

		var result = this.autoService.AutoPointModify(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Automatic PBIS points updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the automatic PBIS points: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	onRowDblClick(School) {}
	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.TriggerLoading == true || this.PBISLoading == true || this.loading == true || this.Processing == true;
	}

	////////////////////////////////////////////////////////////////////////////
}
